import { configureStore } from '@reduxjs/toolkit'
import statusReducer from '../features/statusSlice'
import orgsReducer from '../features/orgsSlice'
import orgReducer from '../features/orgSlice'
import customersReducer from '../features/customersSlice'

export default configureStore({
  reducer: {
    userStatus:statusReducer,
    orgsStatus:orgsReducer,
    orgStatus:orgReducer,
    customers:customersReducer,
  },
})